import { Input as ShadInput } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Icon } from "@/icons/icon"
import { cn } from "@/lib/utils"
import { ChangeEvent, useId, useState } from "react"

export type PasswordInputProps = {
  label?: string
  name?: string
  value?: string
  placeholder?: string
  onChange?: (value: string) => void
  onBlur?: (value: string) => void
}

export default function PasswordInput({
  label = "",
  name,
  value,
  placeholder,
  onChange,
  onBlur,
}: PasswordInputProps) {
  const id = useId()

  const [inputType, setInputType] = useState("password")

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    if (onChange) {
      onChange(e.target.value)
    }
  }

  function handleBlur(e: ChangeEvent<HTMLInputElement>) {
    if (onBlur) {
      onBlur(e.target.value)
    }
  }

  function handleRevealPassToggle() {
    if (inputType === "password") {
      setInputType("text")
    } else {
      setInputType("password")
    }
  }

  return (
    <div>
      {label && (
        <Label className="mb-1.5" htmlFor={id}>
          {label}
        </Label>
      )}

      <div className="relative">
        <ShadInput
          id={id}
          value={value}
          name={name}
          placeholder={placeholder}
          type={inputType}
          onChange={handleChange}
          onBlur={handleBlur}
        />

        <button
          className="absolute top-1/2 right-4 -translate-y-1/2 hover:cursor-pointer"
          type="button"
          onClick={handleRevealPassToggle}
        >
          <span className="sr-only">Show/Hide password</span>
          <Icon
            name="EyeOff"
            className={cn(
              "text-icon size-5",
              inputType === "text" && "text-black"
            )}
          />
        </button>
      </div>
    </div>
  )
}
